<script setup lang="ts">
import FormCategoriaServico from '../components/form-categoriaservico.vue'
import { useCategoriaServicoStore } from '../store/useCategoriaServicoStore'

definePage({
  meta: {
    navActiveLink: 'admin-categoria-servico',
    action: 'edit',
    subject: 'categoria-servico',
  },
})

const store = useCategoriaServicoStore()
const router = useRouter()

const {
  fetchItem,
} = store

fetchItem(router.currentRoute.value.params.id)
</script>

<template>
  <FormCategoriaServico is-editing />
</template>
